<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <div class="add-row h4 mr-2 bold"></div>
      <b-table striped hover :fields="columns" :items="[]">
        <template #head()="scope">
          {{ scope.label }}
        </template>
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(tools)>
          <div class="d-flex justify-content-end">
            <img
              class="b-action-item-disabled"
              src="/icons/edit-disabled.svg"
            />
            <img
              class="b-action-item-disabled"
              src="/icons/delete-disabled.svg"
            />
          </div>
        </template>
      </b-table>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <datatable-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size:14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <template v-slot:label="">
        <div style="min-height: 20px;">
          {{
            computedConditions.label
              ? superComputeFormSubmitterValue({
                  elementId: this.id,
                  property: "label",
                  value: properties.label,
                  defaultValue: "",
                  form: this.form
                })
              : properties.label
          }}
        </div>
      </template>
      <div class="add-row h4 mr-2 bold" @click="addRow"><b-icon-plus /></div>
      <b-table striped hover :fields="columns" :items="controlValue">
        <template #head()="scope">
          <div style="font-size:14px">{{ scope.label }}</div>
        </template>
        <template #cell(index)="data">
          <div style="font-size:14px">{{ data.index + 1 }}</div>
        </template>
        <template #cell(tools)="data">
          <div class="d-flex justify-content-end">
            <img
              class="b-action-item"
              src="/icons/edit.svg"
              @click="editRow(data)"
            />
            <img
              class="b-action-item"
              src="/icons/delete.svg"
              @click="deleteRow(data.index)"
            />
          </div>
        </template>
        <template #cell()="data">
          <div style="font-size:14px">{{ formatCell(data) }}</div>
        </template>
      </b-table>
      <datatable-v-1-row-add-edit-modal
        v-if="showEditor"
        :show="showEditor"
        :fields="columns.filter(f => !f.readOnly)"
        :row="rowToEdit"
        @ok="saveRow"
        @cancel="showEditor = false"
      />
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
      <b-table
        class="form-builder-table"
        striped
        hover
        bordered
        :items="controlValue"
        :fields="columns"
      >
        <template #cell()="data">
          {{ formatCell(data) }}
        </template>
      </b-table>
    </b-form-group>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapMutations, mapState } from "vuex";
import DatatableV1Properties from "./DatatableV1Properties.vue";
import DatatableV1RowAddEditModal from "./DatatableV1RowAddEditModal.vue";

export default {
  name: "DatatableV1",
  components: { DatatableV1Properties, DatatableV1RowAddEditModal },
  props: ["showType", "properties", "form", "id", "results", "formId"],

  data() {
    return {
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false
      },
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      rowToEdit: null,
      showEditor: false
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: this.properties.value
          ? this.superComputeFormSubmitterValue({
              elementId: this.id,
              property: "value",
              value: this.properties.value,
              defaultValue: [],
              form: this.form
            })
          : []
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    addRow() {
      this.rowToEdit = null;
      this.showEditor = true;
    },
    editRow(row) {
      this.rowToEdit = row;
      this.showEditor = true;
    },
    deleteRow(rowIndex) {
      const rows = [...this.controlValue];
      rows.splice(rowIndex, 1);
      this.controlValue = rows;
    },
    saveRow({ data, index }) {
      const rows = [...this.controlValue];

      if (Number.isInteger(index) && index >= 0) {
        rows[index] = data;
      } else {
        rows.push(data);
      }

      this.controlValue = rows;
      this.rowToEdit = null;
      this.showEditor = false;
    },
    formatCell(cell) {
      return this.formatCellData(cell.field.type, cell.value);
    },
    formatCellData(type, value) {
      if (type && value) {
        switch (type) {
          case "date": {
            return moment(value).format("MMM DD, YYYY");
          }
          case "time": {
            return moment(value).format("hh:mm a");
          }
          default: {
            return value;
          }
        }
      }

      return value ? value : "";
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group is-table">
        <legend style="font-size:14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <table role="table" aria-busy="false" aria-colcount="3" class="table b-table form-builder-table table-striped table-hover table-bordered">
            <thead role="rowgroup" class="">
              <tr role="row" class="">
                ${this.columns
                  .slice(1, -1)
                  .map(
                    (column, columnIndex) => `
                <th role="columnheader" scope="col" aria-colindex="${columnIndex +
                  1}" class="">
                  <div style="font-size:14px">${column.label}</div>
                </th>
                `
                  )
                  .join("")}
              </tr>
            </thead>
            <tbody role="rowgroup">
              ${this.controlValue
                .map(
                  item => `
              <tr role="row" class="">
              ${this.columns
                .slice(1, -1)
                .map(
                  (column, columnIndex) => `
                <td style="font-size:14px" aria-colindex="${columnIndex +
                  1}" role="cell" class="" style="word-break: break-word;">${this.formatCellData(
                    column.type,
                    item[column.key]
                  )}</td>
                `
                )
                .join("")}
              </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        let resultControlValue = [];
        if (this.results) resultControlValue = this.results[this.id];
        else {
          const formSubmitterComponentValue = this.getFormSubmitterComponentValue(
            this.id
          );
          if (formSubmitterComponentValue)
            resultControlValue = formSubmitterComponentValue;
        }

        const disallowedKeys = ["_index", "action"];
        return resultControlValue.map(item => ({
          ...Object.keys(item)
            .filter(key => !disallowedKeys.includes(key))
            .reduce((obj, key) => {
              obj[key] = item[key];
              return obj;
            }, {})
        }));
      },
      set(newValue) {
        this.setFormSubmitterComponentValue({
          controlId: this.id,
          controlValue: newValue,
          userAction: true,
          hardSet: true
        });
        this.$emit("update-child-control-value", {
          controlId: this.id,
          controlValue: newValue
        });
        if (this.properties.onChange) {
          this.computeFormSubmitterValue({
            elementId: this.id,
            property: "onChange",
            value: `computed:(${this.properties.onChange})(${JSON.stringify(
              newValue
            )})`,
            defaultValue: null,
            form: this.form,
            statements: true
          });
        }
      }
    },
    columns() {
      const columns = [];
      if (this.showType != "form-viewer") {
        columns.push({
          key: "index",
          label: "#",
          variant: "active",
          class: "text-center font-weight-bold",
          thStyle: "width: 60px",
          readOnly: true
        });
      }

      this.properties.columns
        .map(column => ({
          key: column.field,
          label: column.text,
          type: column.type,
          options: column.options
        }))
        .forEach(column => {
          columns.push(column);
        });

      if (
        this.showType == "form-submitter" ||
        (this.showType == "e-form" && this.properties.eFormEditable)
      ) {
        columns.push({
          key: "tools",
          label: "Tools",
          class: "text-right",
          thStyle: "width: 80px",
          readOnly: true
        });
      }

      return columns;
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style scoped>
.add-row {
  position: absolute;
  top: 0px;
  right: 0px;
}
.add-row:hover {
  cursor: pointer;
}
</style>
<style>
.form-builder-datatable th div {
  word-break: keep-all;
}
</style>
